import Vue from 'vue';
import Axios, { AxiosRequestConfig } from 'axios';
import PerfectScrollbar from 'vue2-perfect-scrollbar';
import device from 'vue-device-detector';
import 'vue2-perfect-scrollbar/dist/vue2-perfect-scrollbar.css';
import 'vueperslides/dist/vueperslides.css';
/* import the fontawesome core */
import { library } from '@fortawesome/fontawesome-svg-core';

/* import font awesome icon component */
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';

/* import specific icons */
import {
  faLinkedin,
  faYoutube,
  faTwitter,
  faFacebookF,
  faInstagram,
  faSpotify,
} from '@fortawesome/free-brands-svg-icons';

import {
  faLocationDot,
  faPhone,
  faEnvelope,
  faAngleDown,
  faAngleUp,
  faChevronLeft,
  faChevronRight,
  faBook,
  faChartPie,
  faBuildingColumns,
  faScroll,
  faChartColumn,
} from '@fortawesome/free-solid-svg-icons';

import App from './App.vue';
// import './registerServiceWorker';
import router from './router';
import store from './store';
import config from './config';

declare module 'vue/types/vue' {
  interface Vue {
    $session: any
  }
}

/* add icons to the library */
library.add(
  faLinkedin,
  faYoutube,
  faTwitter,
  faFacebookF,
  faInstagram,
  faSpotify,
  faLocationDot,
  faPhone,
  faEnvelope,
  faAngleDown,
  faAngleUp,
  faChevronLeft,
  faChevronRight,
  faBook,
  faChartPie,
  faBuildingColumns,
  faScroll,
  faChartColumn,
);

/* add font awesome icon component */
Vue.component('font-awesome-icon', FontAwesomeIcon);
Vue.use(PerfectScrollbar);

Vue.config.productionTip = true;
Vue.use(device);
Vue.use(require('vue-session'), { persist: true });
Vue.use(require('vue-moment'));

Vue.use(require('vue-timeago'), {
  name: 'Timeago',
});

const fSubstr = (text: string, length: number, clamp = '') => {
  if (!text) return '';
  const c = (text.length > length) ? clamp : '';
  return `${text.substr(0, length)}${c}`;
};
Vue.filter('substr', fSubstr);

Axios.defaults.headers.common = {
  Key: config.apiKey,
  Authoziration: Vue.prototype.$session.get('icw_shb_jwt'),
};

// Add a request interceptor
Axios.interceptors.request.use((conf: AxiosRequestConfig) => {
  // Do something before request is sent
  const queryParams = new URLSearchParams(window.location.search);
  conf.headers.Lang = queryParams.get('lang') || 'id';
  return conf;
}, error => Promise.reject(error));

Vue.prototype.$http = Axios;
Vue.prototype.$config = config;

new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app');
